import HomePage from "../pages/HomePage";
import LogInPage from "../pages/LogInPage";
import CancelPage from "../pages/CancelPage";
import SuccessPage from "../pages/SuccessPage";
import LandingPage from "../pages/LandingPage";
import AdsPage from "../pages/AdsPage/AdsPage";
import CretivesByFunnelPage from "../pages/AdsPage/id/CretivesByFunnel.page";
import SettingsPage from "../pages/SettingsPage";
import WebsitesPage from "../pages/WebsitesPage";
import StartSurvery from "../forms/StartSurvery";
import { PlansPage } from "../pages/Plans/PlansPage";
import SalesPage from "../pages/SalesPage/SalesPage";
import LandingOfferPage from "../pages/LandingOfferPage";
import SentryTestPage from "../components/SentryTestPage";
import UserPreferencesPage from "../pages/UserPreferences";
import ProductsPage from "../pages/productPage/productPage";
import { PaymentResultPage } from "../pages/PaymentResultPage";
import AnalyticsPage from "../pages/AnaliticsPage/AnalyticsPage";
import OnboardingFakePage from "../pages/FunnelCreationFakePage";
import AbTestingPage from "../components/ab-testing/AbTestingPage";
import WebsitesBuilderIFramePage from "../pages/WebsiteBuilderIframePage";
import { MembershipPage } from "../pages/membershipsPage/MembershipsPage";
import { IntegrationsPage } from "../pages/Integrations/IntegrationsPage";
import { OrderDetailsPage } from "../pages/OrderDetailsPage/OrderDetailsPage";
import { OnboardingLayout } from "../components/onboardingNew/OnboardingLayout";
import { OnboardingLayoutHome } from "../components/onboardingHome/OnboardingLayoutHome";
import { OnboardingLayoutHomeDemo } from "../components/onboardingHome1/OnboardingLayoutHomeDemo";
import HyphensPage from "@/pages/hyphens/HyphensPage";

export const protectedRoutes = [
  { path: "/ads", element: <AdsPage /> },
  { path: "/hyphens", element: <HyphensPage /> },
  { path: "/home", element: <HomePage /> },
  { path: "/plans", element: <PlansPage /> },
  { path: "/orders", element: <SalesPage /> },
  { path: "/survey", element: <StartSurvery /> },
  { path: "/funnels", element: <WebsitesPage /> },
  { path: "/products", element: <ProductsPage /> },
  { path: "/settings", element: <SettingsPage /> },
  { path: "/ab-testing", element: <AbTestingPage /> },
  { path: "/membership", element: <MembershipPage /> },
  { path: "/sentry-test", element: <SentryTestPage /> },
  { path: "/onboarding", element: <OnboardingLayout /> },
  { path: "/integrations", element: <IntegrationsPage /> },
  { path: "/onboarding1", element: <OnboardingFakePage /> },
  { path: "/order/:hash_id", element: <OrderDetailsPage /> },
  { path: "/analytics/:website_id", element: <AnalyticsPage /> },
  { path: "/onboarding/home", element: <OnboardingLayoutHome /> },
  { path: "/user/preferences", element: <UserPreferencesPage /> },
  { path: "/onboarding1/home1", element: <OnboardingLayoutHomeDemo /> },
];

export const publicRoutes = [
  { path: "/", element: <LandingPage /> },
  { path: "/login", element: <LogInPage /> },
  { path: "/login/offer", element: <LandingOfferPage /> },
  { path: "/payment/:status", element: <PaymentResultPage /> },
  { path: "/payment-subscription/cancel", element: <CancelPage /> },
  { path: "/payment-subscription/success", element: <SuccessPage /> },
  { path: "/website/builder/guest", element: <WebsitesBuilderIFramePage /> },
];
